import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAppBarNavIcon,{on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }